import store from '@src/store';

import { resolveLandingRouteName } from '@pe/router';

export const DASHBOARD_ROUTE_NAME = 'dashboard';

/**
 * Global `router.beforeEach` guard for the Classic Dashboard. Admits users
 * with Exchange access and redirects everyone else to their landing route.
 *
 * APP-29186: registered on the app's router instance via `router.beforeEach`
 * rather than as a `beforeEnter` on the dashboard route object. The route
 * object lives in a `routes` array shared by both the production router and
 * every component test's own router (via tests/helpers/render.js), so a
 * `beforeEnter` embedded there would fire in every test whose router
 * defaults to `/` — most of them. `router.beforeEach` is registered per
 * router instance, so it never reaches a test's router at all.
 *
 * Must never call `next` with a callback for the dashboard branch. The
 * callback form of `next` runs after navigation is confirmed and the
 * component is instantiated, so a redirect issued from there paints the
 * Classic Dashboard before the NextGen UI redirect fires.
 *
 * On a rejected permissions dispatch, forwards the error to `next(err)` so
 * Vue Router aborts navigation and triggers `router.onError` rather than
 * leaving the transition hung.
 */
export function exchangeAccessGuard(to, _, next) {
  if (to.name !== DASHBOARD_ROUTE_NAME) {
    next();
    return;
  }

  return store
    .dispatch('core/getPermissions')
    .then(permissions => {
      const orgUserPermissions = permissions?.orgUser;

      if (orgUserPermissions?.can_access_exchange) {
        next();
      } else {
        next({ name: resolveLandingRouteName(orgUserPermissions) });
      }
    })
    .catch(err => next(err));
}
